import { EuiIcon, IconSize } from "@inscopix/ideas-eui";
import { Tooltip, TooltipProps } from "components/Tooltip/Tooltip";

interface HelpIconToolProps {
  content: TooltipProps["content"];
  size?: IconSize;
  delayShow?: TooltipProps["delayShow"];
}

export const HelpIconTooltip = ({
  content,
  delayShow = 0,
  size,
}: HelpIconToolProps) => {
  return (
    <Tooltip content={content} delayShow={delayShow}>
      <EuiIcon type="questionInCircle" size={size} />
    </Tooltip>
  );
};
